import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { query, collection, onSnapshot, setDoc, doc, deleteDoc, getDocs, getDoc } from "firebase/firestore";
import { connectStorageEmulator } from "firebase/storage";
import { registerClientSnapshotListener } from "./clients";
import { registerDocumentTemplateSnapshotListener } from "./documentTemplates";
import { registerEventSnapshotListener } from "./events";
import { db, getCompanyId, sendError, auth, getCurrentUser, getCurrentUserUID, getCurrentUserAuth } from "./firebase";
import { registerResourceSnapshotListener } from "./resources";
import { registerServiceSnapshotListener } from "./services";
import { registerSettingsSnapshotListener } from "./settings";
import { registerSmsGroupSnapshotListener } from "./smsGroup";
import { registerSmsTemplateSnapshotListener } from "./smsTemplates";
import { registerVersionSnapshotListener } from "./version";


const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotList: any[] = [];
var lastSnapshotMap = new Map();
var companyList: string[] | undefined = undefined;

export function registerUserSnapshotListener(callback: CallableFunction) {
    if (snapshotListener !== null ) {
        callback(getCurrentUser());
        return;
    }
    
    const q = query(collection(db, 'companies/' + getCompanyId() + '/users'));
    //console.log("register userListener");
    snapshotListener = onSnapshot(q, (data: any) => {
        var list: {
            id: any; name: string, surname: string, email: string, phone: string, role: string, color: string, initials: string, baseRate: number, percentageRate: number, individualRate: number, resources: [], sms: boolean, smsTemplates: [], clientsPanel: boolean, birthdaysPanel: boolean, smsPanel: boolean, documentTemplates: [], clientAccess: [], onlyOwnEvents:boolean, enabled:boolean
        }[] = [];
        lastSnapshotMap.clear();
        for(var i=0; i< data.docs.length; i++){
            const doc = data.docs[i];
            const d = doc.data();
            const e = {
                id: doc.id, name: d.name ?? '', surname: d.surname ?? '', email: d.email ?? '',
                phone: d.phone ?? '', role: d.role ?? '', color: d.color, initials: d.initials,
                baseRate: Number.isInteger(d.baseRate) ? d.baseRate : 0,
                percentageRate: Number.isInteger(d.percentageRate) ? d.percentageRate : 0,
                individualRate: Number.isInteger(d.individualRate) ? d.individualRate : 0,
                resources: d.resources, sms: d.sms, smsTemplates: d.smsTemplates,
                clientsPanel: d.clientsPanel ?? true,
                birthdaysPanel: d.birthdaysPanel ?? d.clientsPanel ?? true,
                smsPanel: d.smsPanel ?? false, documentTemplates: d.documentTemplates, clientAccess: d.clientAccess,
                onlyOwnEvents: d.onlyOwnEvents ?? false, enabled:d.enabled
            }
            //if(d.enabled){
                list.push(e);
            //}
            lastSnapshotMap.set(doc.id, e);
        }
        
        list = list.sort((a: any, b: any) => {
            var r = a.surname.localeCompare(b.surname);
            if (r === 0) {
                return a.name.localeCompare(b.name)
            }
            return r;
        })
        lastSnapshotList = list;
        listeners.forEach(callback => {
            callback(list);
        });

        registerClientSnapshotListener();
        registerEventSnapshotListener();
        registerResourceSnapshotListener();
        registerSmsTemplateSnapshotListener();
        registerServiceSnapshotListener();
        registerDocumentTemplateSnapshotListener();
        registerVersionSnapshotListener();
        if (getCurrentUser().smsPanel) {            
            registerSmsGroupSnapshotListener();
        }
        if (getCurrentUser().manager || getCurrentUser().sms) {
            registerSettingsSnapshotListener();
        }
        //console.log("registerUserSnapshotListener",getCurrentUser());
        callback(getCurrentUser());
    }, (err) => {
        console.log("onUserChange error => " + err.message);
        sendError(err.message);
    })
}

export async function unregisterUserSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister unregisterUserSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addUserListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotList.length > 0) {
        callback(lastSnapshotList);
    }
}

export function createUserAccount(data: { email: string, name: string, surname: string, initials: string, role: string, baseRate: number, percentageRate: number, individualRate: number, resources: [], smsTemplates: [], sms: boolean, color: string, clientsPanel: boolean, birthdaysPanel: boolean, smsPanel: boolean, documentTemplates: [], clientAccess: [], onlyOwnEvents: boolean, enabled: boolean }, password: string, callback: CallableFunction) {
    let originalUser = auth.currentUser;
    for (var i = 0; i < lastSnapshotList.length; i++) {
        if (lastSnapshotList[i].email === data.email) {
            sendError("Podany email już istnieje!");
            return;
        }
    }
    createUserWithEmailAndPassword(auth, data.email, password)
        .then(async (userCredential) => {
            await auth.updateCurrentUser(originalUser);
            try {
                await setDoc(doc(db, 'companies/' + getCompanyId() + '/users', userCredential.user.uid), data, { merge: true });
                await sendEmailVerification(userCredential.user);
                callback(true);
            } catch (error) {
                console.error(error);
                sendError("Nie można dodać Użytkownika!");
            }

        })
        .catch((error) => {
            console.error("onCreateUserWithEmailAndPassword error => " + error.message);
            if (error.message.includes("email-already-in-use")) {
                sendError("email jest przypisany do innego obszaru roboczego! Skontatkuj się z administratorem!");
            } else {
                sendError(error.message);
            }

        });
}




export async function setUser(data: { email: string, name: string, surname: string, initials: string, role: string, baseRate: number, percentageRate: number, individualRate: number, resources: [], smsTemplates: [], sms: boolean, color: string, clientsPanel: boolean, birthdaysPanel: boolean, smsPanel: boolean, documentTemplates: [], clientAccess: [], onlyOwnEvents: boolean, enabled: boolean }, id: string, callback: CallableFunction) {
    try {
        await setDoc(doc(db, 'companies/' + getCompanyId() + '/users', id), data, { merge: true });
        callback(true);
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić Użytkownika!");
    }
}

export async function deleteUser(id: string) {
    try {
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/users', id));
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć Użytkownika!");
    }
}

export function getUsers() {
    return lastSnapshotList;
}

export function getActiveUsers(userId:string) {
    var list = [];
    for (var i = 0; i < lastSnapshotList.length; i++) {
        if (lastSnapshotList[i].id===userId || lastSnapshotList[i].enabled) {
            list.push(lastSnapshotList[i]);
        }
    }
    return list;
}

export function getUser(id: string) {
    return lastSnapshotMap.get(id);

}


